import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { autoUpdate as Z, flip as ee, inner as te, offset as ne, shift as le, size as re, useFloating as oe, useInnerOffset as ie, useInteractions as se } from "@floating-ui/react";
import * as j from "react";
import { createContext as _, useCallback as ae, useContext as R, useMemo as v, useRef as ue, useState as E } from "react";
import { useDisposables as fe } from '../hooks/use-disposables.js';
import { useEvent as z } from '../hooks/use-event.js';
import { useIsoMorphicEffect as A } from '../hooks/use-iso-morphic-effect.js';
var y = _({
  styles: void 0,
  setReference: function setReference() {},
  setFloating: function setFloating() {},
  getReferenceProps: function getReferenceProps() {
    return {};
  },
  getFloatingProps: function getFloatingProps() {
    return {};
  },
  slot: {}
});
y.displayName = "FloatingContext";
var S = _(null);
S.displayName = "PlacementContext";
function xe(e) {
  return v(function () {
    return e ? typeof e == "string" ? {
      to: e
    } : e : null;
  }, [e]);
}
function ye() {
  return R(y).setReference;
}
function Fe() {
  return R(y).getReferenceProps;
}
function be() {
  var _R = R(y),
    e = _R.getFloatingProps,
    t = _R.slot;
  return ae(function () {
    return Object.assign({}, e.apply(void 0, arguments), {
      "data-anchor": t.anchor
    });
  }, [e, t]);
}
function Re() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  e === !1 && (e = null), typeof e == "string" && (e = {
    to: e
  });
  var t = R(S),
    n = v(function () {
      return e;
    }, [JSON.stringify(e, typeof HTMLElement != "undefined" ? function (r, o) {
      return o instanceof HTMLElement ? o.outerHTML : o;
    } : void 0)]);
  A(function () {
    t == null || t(n != null ? n : null);
  }, [t, n]);
  var l = R(y);
  return v(function () {
    return [l.setFloating, e ? l.styles : {}];
  }, [l.setFloating, e, l.styles]);
}
var q = 4;
function ve(_ref) {
  var e = _ref.children,
    _ref$enabled = _ref.enabled,
    t = _ref$enabled === void 0 ? !0 : _ref$enabled;
  var _E = E(null),
    _E2 = _slicedToArray(_E, 2),
    n = _E2[0],
    l = _E2[1],
    _E3 = E(0),
    _E4 = _slicedToArray(_E3, 2),
    r = _E4[0],
    o = _E4[1],
    c = ue(null),
    _E5 = E(null),
    _E6 = _slicedToArray(_E5, 2),
    u = _E6[0],
    s = _E6[1];
  pe(u);
  var i = t && n !== null && u !== null,
    _ce = ce(n, u),
    _ce$to = _ce.to,
    F = _ce$to === void 0 ? "bottom" : _ce$to,
    _ce$gap = _ce.gap,
    C = _ce$gap === void 0 ? 0 : _ce$gap,
    _ce$offset = _ce.offset,
    M = _ce$offset === void 0 ? 0 : _ce$offset,
    _ce$padding = _ce.padding,
    p = _ce$padding === void 0 ? 0 : _ce$padding,
    P = _ce.inner,
    _F$split = F.split(" "),
    _F$split2 = _slicedToArray(_F$split, 2),
    a = _F$split2[0],
    _F$split2$ = _F$split2[1],
    f = _F$split2$ === void 0 ? "center" : _F$split2$;
  A(function () {
    i && o(0);
  }, [i]);
  var _oe = oe({
      open: i,
      placement: a === "selection" ? f === "center" ? "bottom" : "bottom-".concat(f) : f === "center" ? "".concat(a) : "".concat(a, "-").concat(f),
      strategy: "absolute",
      transform: !1,
      middleware: [ne({
        mainAxis: a === "selection" ? 0 : C,
        crossAxis: M
      }), le({
        padding: p
      }), a !== "selection" && ee({
        padding: p
      }), a === "selection" && P ? te(_objectSpread(_objectSpread({}, P), {}, {
        padding: p,
        overflowRef: c,
        offset: r,
        minItemsVisible: q,
        referenceOverflowThreshold: p,
        onFallbackChange: function onFallbackChange(h) {
          var O, W;
          if (!h) return;
          var d = g.elements.floating;
          if (!d) return;
          var T = parseFloat(getComputedStyle(d).scrollPaddingBottom) || 0,
            $ = Math.min(q, d.childElementCount),
            B = 0,
            N = 0;
          var _iterator = _createForOfIteratorHelper((W = (O = g.elements.floating) == null ? void 0 : O.childNodes) != null ? W : []),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var m = _step.value;
              if (m instanceof HTMLElement) {
                var x = m.offsetTop,
                  k = x + m.clientHeight + T,
                  H = d.scrollTop,
                  U = H + d.clientHeight;
                if (x >= H && k <= U) $--;else {
                  N = Math.max(0, Math.min(k, U) - Math.max(x, H)), B = m.clientHeight;
                  break;
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          $ >= 1 && o(function (m) {
            var x = B * $ - N + T;
            return m >= x ? m : x;
          });
        }
      })) : null, re({
        padding: p,
        apply: function apply(_ref2) {
          var h = _ref2.availableWidth,
            d = _ref2.availableHeight,
            T = _ref2.elements;
          Object.assign(T.floating.style, {
            overflow: "auto",
            maxWidth: "".concat(h, "px"),
            maxHeight: "min(var(--anchor-max-height, 100vh), ".concat(d, "px)")
          });
        }
      })].filter(Boolean),
      whileElementsMounted: Z
    }),
    b = _oe.refs,
    w = _oe.floatingStyles,
    g = _oe.context,
    _g$placement$split = g.placement.split("-"),
    _g$placement$split2 = _slicedToArray(_g$placement$split, 2),
    _g$placement$split2$ = _g$placement$split2[0],
    I = _g$placement$split2$ === void 0 ? a : _g$placement$split2$,
    _g$placement$split2$2 = _g$placement$split2[1],
    V = _g$placement$split2$2 === void 0 ? f : _g$placement$split2$2;
  a === "selection" && (I = "selection");
  var G = v(function () {
      return {
        anchor: [I, V].filter(Boolean).join(" ")
      };
    }, [I, V]),
    K = ie(g, {
      overflowRef: c,
      onChange: o
    }),
    _se = se([K]),
    Q = _se.getReferenceProps,
    X = _se.getFloatingProps,
    Y = z(function (h) {
      s(h), b.setFloating(h);
    });
  return j.createElement(S.Provider, {
    value: l
  }, j.createElement(y.Provider, {
    value: {
      setFloating: Y,
      setReference: b.setReference,
      styles: w,
      getReferenceProps: Q,
      getFloatingProps: X,
      slot: G
    }
  }, e));
}
function pe(e) {
  A(function () {
    if (!e) return;
    var t = new MutationObserver(function () {
      var n = window.getComputedStyle(e).maxHeight,
        l = parseFloat(n);
      if (isNaN(l)) return;
      var r = parseInt(n);
      isNaN(r) || l !== r && (e.style.maxHeight = "".concat(Math.ceil(l), "px"));
    });
    return t.observe(e, {
      attributes: !0,
      attributeFilter: ["style"]
    }), function () {
      t.disconnect();
    };
  }, [e]);
}
function ce(e, t) {
  var o, c, u;
  var n = L((o = e == null ? void 0 : e.gap) != null ? o : "var(--anchor-gap, 0)", t),
    l = L((c = e == null ? void 0 : e.offset) != null ? c : "var(--anchor-offset, 0)", t),
    r = L((u = e == null ? void 0 : e.padding) != null ? u : "var(--anchor-padding, 0)", t);
  return _objectSpread(_objectSpread({}, e), {}, {
    gap: n,
    offset: l,
    padding: r
  });
}
function L(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
  var l = fe(),
    r = z(function (s, i) {
      if (s == null) return [n, null];
      if (typeof s == "number") return [s, null];
      if (typeof s == "string") {
        if (!i) return [n, null];
        var F = J(s, i);
        return [F, function (C) {
          var M = D(s);
          {
            var p = M.map(function (P) {
              return window.getComputedStyle(i).getPropertyValue(P);
            });
            l.requestAnimationFrame(function P() {
              l.nextFrame(P);
              var a = !1;
              var _iterator2 = _createForOfIteratorHelper(M.entries()),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _step2$value = _slicedToArray(_step2.value, 2),
                    b = _step2$value[0],
                    w = _step2$value[1];
                  var g = window.getComputedStyle(i).getPropertyValue(w);
                  if (p[b] !== g) {
                    p[b] = g, a = !0;
                    break;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              if (!a) return;
              var f = J(s, i);
              F !== f && (C(f), F = f);
            });
          }
          return l.dispose;
        }];
      }
      return [n, null];
    }),
    o = v(function () {
      return r(e, t)[0];
    }, [e, t]),
    _E7 = E(),
    _E8 = _slicedToArray(_E7, 2),
    _E8$ = _E8[0],
    c = _E8$ === void 0 ? o : _E8$,
    u = _E8[1];
  return A(function () {
    var _r = r(e, t),
      _r2 = _slicedToArray(_r, 2),
      s = _r2[0],
      i = _r2[1];
    if (u(s), !!i) return i(u);
  }, [e, t]), c;
}
function D(e) {
  var t = /var\((.*)\)/.exec(e);
  if (t) {
    var n = t[1].indexOf(",");
    if (n === -1) return [t[1]];
    var l = t[1].slice(0, n).trim(),
      r = t[1].slice(n + 1).trim();
    return r ? [l].concat(_toConsumableArray(D(r))) : [l];
  }
  return [];
}
function J(e, t) {
  var n = document.createElement("div");
  t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
  var l = parseFloat(window.getComputedStyle(n).marginTop) || 0;
  return t.removeChild(n), l;
}
export { ve as FloatingProvider, Re as useFloatingPanel, be as useFloatingPanelProps, ye as useFloatingReference, Fe as useFloatingReferenceProps, xe as useResolvedAnchor };